import React, {memo} from 'react';
import {Default} from "../Default/Default";
import {scenarioItems} from "../ScenarioItems/index.";

const Frame = memo(({dataItem, currentScenario, cardIndex, scenarioIndex, currentCardIndex, currentScenarioIndex}) => {
    const {field: role} = currentScenario;

    function isNotVisible() {
        if (cardIndex > currentCardIndex) {
            return true;
        }
        if (cardIndex === currentCardIndex && scenarioIndex > currentScenarioIndex) {
            return true
        }
    }

    if (isNotVisible()) return null;

    let RenderComponent = scenarioItems[currentScenario.type]?.component || Default;

    return (
        <RenderComponent
            dataItem={dataItem}
            cardIndex={cardIndex}
            scenarioIndex={scenarioIndex}
            field={role}
        />
    );
});

export {Frame};